import Svg, { Path } from 'react-native-svg'

export const CheckboxOff = ({ height = 16, width = 16, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path stroke={color} d="M.5.5h15v15H.5z" />
    </Svg>
  )
}

export const CheckboxOn = ({ height = 16, width = 16, color = '#0F3CC9' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path fill={color} d="M0 0h16v16H0z" />
      <Path
        fill="#fff"
        d="M6 12.667a.668.668 0 0 1-.473-.193L2.193 9.141a.67.67 0 1 1 .947-.947L6 11.061l6.86-6.867a.67.67 0 0 1 .947.947l-7.334 7.333a.667.667 0 0 1-.473.193Z"
      />
    </Svg>
  )
}
